var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg44(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1348.2 254.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:#262626;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -353.03,
    y1: -720.76,
    x2: -352.82,
    y2: -720.76,
    gradientTransform: "matrix(212.46, 822.5, 822.5, -212.46, 667979.84, 137268.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ff8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#53fdb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68fcbb"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M360.4,57.2c12.3,47.7-228.5,165.7-337.7,193.9S233.6,140.9,221.3,93.2-46.3,84.6,62.8,56.4,348.1,9.5,360.4,57.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M537.5,179.9c0,9.7.3,26.4,21.9,26.4a89.7,89.7,0,0,0,12.2-.7v40.5a205.3,205.3,0,0,1-21.5,1.3c-37.3,0-60.1-6.7-60.1-44v-98H468.4V63.3H490V16.1h47.5V63.3h35.4v42.1H537.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M601.5,155.2c0-72.6,62.9-91.9,96-91.9,45.3,0,90.6,30.8,92.2,87.7,0,13.5-.9,22.2-.9,22.2H649.3c5.8,28.9,38.6,32.1,48.2,32.1,26.7,0,39.9-14.4,45.3-20.6l37.3,21.6c-7.1,9.6-30.8,41.1-82.6,41.1C663.1,247.4,601.5,227.8,601.5,155.2Zm49.1-16.1H739c-2-16-17.7-33.7-41.8-33.7C669.6,105.4,652.5,121.1,650.6,139.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M828.9,0h48.2V242.9H828.9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M923.4,0h48.2V242.9H923.4Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1009.2,154.9c0-50.5,43.1-91.9,95.7-91.9s96.4,41.4,96.4,91.9-43.7,92.2-96.4,92.2S1009.2,206,1009.2,154.9Zm47.2,0c0,29.2,20.9,50.4,48.5,50.4s48.6-21.8,48.6-50.4-21.2-49.8-48.6-49.8S1056.4,126.9,1056.4,154.9Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1287.8,164.8v78.1h-47.9V66.2h47.9V89.6c18-23.7,47.8-26.9,60.4-26.6v46.9C1336.6,108.9,1287.8,111.2,1287.8,164.8Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg44);
export default __webpack_public_path__ + "static/media/44.bc829936c41c75cc6714cddc6d4ecf77.svg";
export { ForwardRef as ReactComponent };